import { type FC } from "react";

export const ChartAlt: FC = () => (
  <svg
    width="50"
    height="50"
    viewBox="0 0 50 50"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M35.4167 18.75L29.0748 28.263C28.1875 29.5939 26.1933 29.4698 25.4779 28.039L24.5222 26.1276C23.8068 24.6969 21.8127 24.5727 20.9254 25.9037L14.5834 35.4167"
      stroke="#1AACFF"
      strokeWidth="4.16667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <rect
      x="6.25"
      y="6.25"
      width="37.5"
      height="37.5"
      rx="4.16667"
      stroke="#1AACFF"
      strokeWidth="4.16667"
    />
  </svg>
);
